import { render, staticRenderFns } from "./FamilyBtn.vue?vue&type=template&id=7d3b67b0&scoped=true&"
import script from "./FamilyBtn.vue?vue&type=script&lang=js&"
export * from "./FamilyBtn.vue?vue&type=script&lang=js&"
import style0 from "./FamilyBtn.vue?vue&type=style&index=0&id=7d3b67b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3b67b0",
  null
  
)

export default component.exports